<template lang="pug">
  .wrap

    template(v-if='!showPlaceholder')
      page-title Your Alerts
        span(slot='subtitle') Alerts are messages that can be sent to your team at any time. You can set a start and end time for your alerts so they can be seen at a specific time.

      list-header(:on-search='search')
        check-permission(slot='action' type='alerts' can='add')
          router-link(:to="{ name: 'alertCreate' }")
            el-button(type="primary") Add New Alert

      el-table(:data="list.results" empty-text="No entries" v-loading='loading' @sort-change='changeSort')
        el-table-column(width="100" align='center' label='Status' class-name='status-cell')
          template(slot-scope="scope")
            icon.status-icon(v-if='scope.row.status === "published"' name='check-circle' color='#7fc4be' :scale='1.5')
            icon.status-icon(v-if='scope.row.status === "draft"' name='times-circle' color='#dd6e69' :scale='1.5')
        el-table-column(label="Alert" sortable prop='subject' class-name='title-cell' min-width="250")
          template(slot-scope="scope")
            div(@click='navigateToEdit(scope.row.id)')
              .subject {{ scope.row.subject }}
              .message {{ formatMessage(scope.row.message) }}

        el-table-column(label="Groups assigned" width="250")
          template(slot-scope="scope")
            el-tag.assigned-group(type="primary" v-for='group in assignedGroupList(scope.row)' :key='group.id') {{ group.name }}

        el-table-column(label="Start" sortable prop='startDatetime' width='170')
          template(slot-scope="scope")
            .schedule
              .schedule-time {{ scheduleTime(scope.row.startDatetime) }}
              .schedule-day {{ scheduleDay(scope.row.startDatetime) }}
        el-table-column(label="End" sortable prop='endDatetime' width='170')
          template(slot-scope="scope")
            .schedule
              .schedule-time {{ scheduleTime(scope.row.endDatetime) }}
              .schedule-day {{ scheduleDay(scope.row.endDatetime) }}

        el-table-column(width='120' align='center')
          template(slot-scope="scope")
            check-permission(type='alerts' can='edit')
              el-button.table-button(size='small' @click='navigateToEdit(scope.row.id)')
                icon.report-icon(name='edit' color='#999')
                | Edit

      .pages
        el-pagination(layout="prev, pager, next" @current-change='changePage' :total="list.count" :page-size='pageSize')

    .empty(v-else)
      alert-list-empty

</template>

<script>
import _ from "lodash";
import { mapActions } from "vuex";
import format from "date-fns/format";
import PageTitle from "@/shared/components/layout/PageTitle";
import ListHeader from "@/shared/components/ListHeader";
import AlertListEmpty from "../AlertListEmpty";

export default {
  components: { PageTitle, ListHeader, AlertListEmpty },
  data() {
    return {
      loading: true,
      pageSize: 20,
      searchParams: null,
      list: {
        retults: [],
        count: 0
      }
    };
  },
  computed: {
    showPlaceholder() {
      return !this.loading && !this.searchParams && !this.list.count;
    }
  },
  methods: {
    ...mapActions({
      fetchAlerts: "alerts/fetchAlerts"
    }),
    loadList({ params } = {}) {
      const mergedParams = {
        pageSize: this.pageSize,
        ...params
      };
      this.loading = true;
      this.fetchAlerts({ params: mergedParams }).then(data => {
        this.loading = false;
        this.list = data;
      });
    },
    formatMessage(msg) {
      return _.truncate(msg, { length: 100 });
    },
    search(q) {
      if (q) {
        this.searchParams = { q };
      } else {
        this.searchParams = null;
      }
      this.loadList({ params: { q } });
    },
    navigateToEdit(alertId) {
      this.$router.push({ name: "alertEdit", params: { alertId } });
    },
    scheduleTime(date) {
      return format(date, "HH:mm");
    },
    scheduleDay(date) {
      return format(date, "ddd D MMMM");
    },
    assignedGroupList(alert) {
      return _.filter(
        alert.assignees.map(a => _.get(a, "appLicenseGroup.group"))
      );
    },
    changeSort({ prop, order }) {
      if (!order) {
        this.loadList();
        return;
      }
      const sortVal = (order === "ascending" ? "" : "-") + prop;
      this.loading = true;
      this.loadList({ params: { sort: sortVal } });
    },
    changePage(page) {
      this.loadList({ params: { page } });
    }
  },
  created() {
    this.loadList();
  }
};
</script>

<style scoped lang="scss">
.emptystate {
  width: 100%;
}

.message {
  font-size: 13px;
  color: #666;
  line-height: 20px;
}

.wrap {
  :global(td.stat-cell .cell) {
    font-size: 16px;
    line-height: 20px;
    padding: 20px 0;
  }

  :global(td .cell) {
    line-height: 24px;
  }

  :global(.status-cell .cell) {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  :global(td.title-cell) {
    font-size: 16px;
    cursor: pointer;
  }
}

.schedule {
  display: flex;
  // align-items: center;
  justify-content: center;
  flex-direction: column;
}

.schedule-time {
  font-size: 16px;
}

.schedule-day {
  color: #666;
}

.report-icon {
  margin-right: 8px;
}

.pages {
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #999;
  border: 1px solid #ddd;
  border-radius: 2px;
  background: white;
  padding: 80px 0;
  flex-direction: column;
}

.placeholder-actions {
  margin-top: 30px;
}

.emptystate {
  width: 100%;
}

.assigned-group {
  margin-right: 5px;
  margin-bottom: 4px;
  &:last-child {
    margin-right: 0;
  }
}
</style>
